// extracted by mini-css-extract-plugin
export default {"formRow":"PPForm_formRow__pUsDn","errorBox":"PPForm_errorBox__EuDPq"};